const env =
  process.env.REACT_APP_ENV || typeof window !== "undefined"
    ? window.location.hostname.includes("localhost")
      ? "staging"
      : "production"
    : "production";

const docsDomain =
  process.env.REACT_APP_DOCS_DOMAIN || "https://docs.stg.shoppxy.com";
const pageDomain =
  process.env.REACT_APP_PAGE_DOMAIN || "https://stg.shoppxy.com";

const autoChargeEnabled = true;// process.env.REACT_APP_AUTO_CHARGE_ENABLED === "true";

export default {
  env,
  docsDomain,
  pageDomain,
  autoChargeEnabled,
};
